import { useMemo } from "react";
import { useNavigationHistoryPath } from "../store";
import { point as createPoint } from "@turf/helpers";
import { distance } from "@turf/distance";

export const useCalculateTotalPathDistance = (): number => {
  const path = useNavigationHistoryPath();
  return useMemo(() => {
    const totalDistance =
      path?.reduce<number>((total, item): number => {
        const [from, to] = item.locations;

        const fromPoint = createPoint([from.longitude, from.latitude]);
        const toPoint = createPoint([to.longitude, to.latitude]);

        return total + distance(fromPoint, toPoint, { units: "kilometers" });
      }, 0) ?? 0;

    return Math.round(totalDistance);
  }, [path]);
};
